import { Box, Typography, Button } from "@mui/material";
import { formatarTelefone, formatDateBR } from "../../shared/utils";
import { useEffect, useState } from "react";
import { caixaDeEntradaService } from "./service/caixa-de-entrada.service";

interface CaixaDeEntradaItem {
  id: string;
  idCompany: string;
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  dateMessage: string;
}

interface VisualizarMensagemProps {
  mensagem: CaixaDeEntradaItem;
  onClose: () => void;
}


function VisualizarMensagem({ mensagem, onClose }: VisualizarMensagemProps) {
  const [mensagemDetalhe, setMensagemDetalhe] = useState<CaixaDeEntradaItem | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let ativo = true;
    setLoading(true);
    caixaDeEntradaService.detalhar(mensagem.id)
      .then((result) => {
        if (ativo) setMensagemDetalhe(result);
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });
    return () => { ativo = false; };
  }, [mensagem]);

  if (!mensagem) return null;

  return (
    <Box
      p={4}
      borderRadius={2}
      boxShadow={24}
      minWidth={350}
      maxWidth={500}
      mx="auto"
      mt="10vh"
      display="flex"
      flexDirection="column"
      gap={2}
      bgcolor="background.paper"
      color="text.primary"
    >
      <Typography variant="h6">Mensagem Completa</Typography>
      {loading || !mensagemDetalhe ? (
        <Typography>Carregando...</Typography>
      ) : (
        <>
          <Typography variant="subtitle2">Nome: {mensagemDetalhe.name}</Typography>
          <Typography variant="subtitle2">Email: {mensagemDetalhe.email}</Typography>
          <Typography variant="subtitle2">Telefone: {formatarTelefone(mensagemDetalhe.phone)}</Typography>
          <Typography variant="subtitle2">Assunto: {mensagemDetalhe.subject}</Typography>
          <Typography variant="subtitle2">Data: {formatDateBR(mensagemDetalhe.dateMessage)}</Typography>
          <Typography variant="body1" sx={{ mt: 2, whiteSpace: 'pre-line' }}>
            {mensagemDetalhe.message}
          </Typography>
        </>
      )}
      <Button variant="contained" onClick={onClose}>
        Fechar
      </Button>
    </Box>
  );
}

export default VisualizarMensagem;
